import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const LOGO_URL = 'https://i.imgur.com/8iD261r.jpeg';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-28 sm:pt-32 pb-16" data-testid="about-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="uppercase text-xs tracking-[0.2em] text-[#C4A35A] font-medium mb-2">Our Story</p>
          <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl text-[#E8D5A3] mb-4">About CandleCraze Designs & More</h1>
          <p className="font-['Cormorant_Garamond'] text-lg text-[#C4A35A] italic">Effortless Beauty, Sweetly Done</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <img
              src={LOGO_URL}
              alt="CandleCraze Designs & More"
              className="w-full max-w-sm mx-auto rounded-2xl cc-gold-glow"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="space-y-6"
          >
            <h2 className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl text-[#E8D5A3]">Handcrafted with Love</h2>
            <p className="text-sm text-[#9A8E7A] leading-relaxed">
              At CandleCraze Designs & More, we believe that every moment deserves a touch of luxury. Our journey started with a simple passion for creating beautiful, clean-burning candles that fill your space with warmth and fragrance.
            </p>
            <p className="text-sm text-[#9A8E7A] leading-relaxed">
              Hand-poured in Egg Harbor Township, New Jersey, each of our products is crafted with premium soy, coconut-apricot, and white beeswax blends. We use ECO cotton and wooden crackling wicks to deliver a powerful hot and cold throw that transforms any room.
            </p>
            <p className="text-sm text-[#9A8E7A] leading-relaxed">
              We've grown from candles and wax melts into a full line of beauty and home products, including luxurious soap scrubs, body care essentials, and room sprays. Just like Bath & Body Works, but with a personal, artisan touch.
            </p>
          </motion.div>
        </div>

        {/* Values */}
        <div className="bg-[#141414] border border-[#2A2520] rounded-2xl p-8 sm:p-12 mb-16">
          <h2 className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl text-[#E8D5A3] text-center mb-10">What We Stand For</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <h3 className="font-['Cormorant_Garamond'] text-xl text-[#E8D5A3] font-medium mb-2">Quality First</h3>
              <p className="text-sm text-[#9A8E7A] leading-relaxed">
                We source only the finest ingredients for every product. From our wax blends to our skincare formulations, quality is never compromised.
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-['Cormorant_Garamond'] text-xl text-[#E8D5A3] font-medium mb-2">Eco-Conscious</h3>
              <p className="text-sm text-[#9A8E7A] leading-relaxed">
                Sustainability matters. Our clean-burning formulas and eco-friendly packaging reflect our commitment to the planet.
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-['Cormorant_Garamond'] text-xl text-[#E8D5A3] font-medium mb-2">Community Love</h3>
              <p className="text-sm text-[#9A8E7A] leading-relaxed">
                Every candle tells a story. We love connecting with our community through social media, local events, and your amazing feedback.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <h2 className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl text-[#E8D5A3] mb-4">Ready to Experience the Glow?</h2>
          <Button asChild className="bg-[#C4A35A] hover:bg-[#D4B86A] text-[#0A0A0A] rounded-full px-8 py-3 h-auto text-sm font-bold" data-testid="about-shop-btn">
            <Link to="/shop">
              Browse Our Collection <ArrowRight size={16} className="ml-2 inline" />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
